    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                    @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">

                        <el-form-item label="姓名:">
                            <el-input v-model="table.where.name" placeholder="请输入姓名" clearable />
                        </el-form-item>

                        <el-form-item label="用户:">
                            <el-select v-model="table.where.user_id" filterable placeholder="请选择">
                                <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="手机号:">
                            <el-input v-model="table.where.phone" placeholder="请输入手机号" clearable />
                        </el-form-item>

                        <el-form-item label="性别:">
                            <el-select v-model="table.where.gender" filterable placeholder="请选择">
                                <el-option label="未知" value="0"></el-option>
                                <el-option label="男" value="1"></el-option>
                                <el-option label="女" value="2"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="行业:">
                            <el-input v-model="table.where.industry" placeholder="请输入行业" clearable />
                        </el-form-item>

                        <el-form-item label="从业年数:">
                            <el-input-number v-model="table.where.year_num" placeholder="请输入从业年数" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="加盟区域:">
                            <el-input v-model="table.where.join_area" placeholder="请输入加盟区域" clearable />
                        </el-form-item>

                        <el-form-item label="人口数:">
                            <el-input v-model="table.where.population" placeholder="请输入人口数" clearable />
                        </el-form-item>

                        <el-form-item label="资金实力:">
                            <el-input v-model="table.where.price" placeholder="请输入资金实力" clearable />
                        </el-form-item>

                        <el-form-item label="描述:">
                            <el-input v-model="table.where.info" placeholder="请输入描述" clearable />
                        </el-form-item>

                        <el-form-item label="操盘团队（3-5人）:">
                            <el-input-number v-model="table.where.team" placeholder="请输入操盘团队（3-5人）" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="创建时间:">
                            <el-date-picker v-model="table.where.create_time" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download"
                                class="ele-btn-icon" v-if="permission.includes('sys:join:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                        class="ele-btn-icon" size="small">刷新
                    </el-button>
                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon"
                        size="small" v-if="permission.includes('sys:join:add')">添加
                    </el-button>
                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                        v-if="permission.includes('sys:join:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                        @click="search_show=!search_show">搜索</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                    highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left" />
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                            show-overflow-tooltip />
                        <el-table-column prop="status" label="状态" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-if="row.status == 1">待审核</el-tag>
                                <el-tag v-if="row.status == 2">通过审核</el-tag>
                                <el-tag v-if="row.status == 3">拒绝通过</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="user_id" label="用户" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-for="(item,index) in row.user_id_info"
                                    :key="index">{{item.nick_name+item.phone}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="姓名" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                       
                        <el-table-column prop="phone" label="手机号" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="gender" label="性别" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-if="row.gender == 0" :key="index">未知</el-tag>
                                <el-tag v-if="row.gender == 1" :key="index">男</el-tag>
                                <el-tag v-if="row.gender == 2" :key="index">女</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column prop="industry" label="行业" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="year_num" label="从业年数" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="join_area" label="加盟区域" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="population" label="人口数" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="price" label="资金实力" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="info" label="描述" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="team" label="操盘团队（3-5人）" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="user_id_info.nick_name" label="用户昵称" sortable="custom"
                            show-overflow-tooltip min-width="120">
                            <template slot-scope="{row}">
                                <div v-for="(item,index) in row.user_id_info" :key="index">
                                    {{ item.nick_name }}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                    v-if="permission.includes('sys:join:edit')">修改</el-link>
                                <el-popconfirm title="确定要删除此加盟申请吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                        v-if="permission.includes('sys:join:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改加盟申请':'添加加盟申请'" :visible.sync="showEdit" width="800px"
                :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                <el-form-item label="状态:" prop="status">
                        <el-select v-model="editForm.status" filterable placeholder="请选择性别">
                            <el-option label="待审核" value="1"></el-option>
                            <el-option label="通过审核" value="2"></el-option>
                            <el-option label="拒绝通过" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="姓名:" prop="name">
                        <el-input v-model="editForm.name" placeholder="请输入姓名" clearable />
                    </el-form-item>


                    <el-form-item label="用户:" prop="user_id">
                        <el-select v-model="editForm.user_id" filterable placeholder="请选择">
                            <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                                :value="item.id">
                            </el-option>
                        </el-select>

                    </el-form-item>

                    <el-form-item label="手机号:" prop="phone">
                        <el-input v-model="editForm.phone" placeholder="请输入手机号" clearable />
                    </el-form-item>

                    <el-form-item label="性别:" prop="gender">
                        <el-select v-model="editForm.gender" filterable placeholder="请选择性别">
                            <el-option label="未知" value="0"></el-option>
                            <el-option label="男" value="1"></el-option>
                            <el-option label="女" value="2"></el-option>
                        </el-select>
                    </el-form-item>


                    <el-form-item label="行业:" prop="industry">
                        <el-input v-model="editForm.industry" placeholder="请输入行业" clearable />
                    </el-form-item>

                    <el-form-item label="从业年数:" prop="year_num">
                        <el-input-number v-model="editForm.year_num" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入从业年数" clearable />
                    </el-form-item>

                    <el-form-item label="加盟区域:" prop="join_area">
                        <el-input v-model="editForm.join_area" placeholder="请输入加盟区域" clearable />
                    </el-form-item>

                    <el-form-item label="人口数:" prop="population">
                        <el-input v-model="editForm.population" placeholder="请输入人口数" clearable />
                    </el-form-item>

                    <el-form-item label="资金实力:" prop="price">
                        <el-input v-model="editForm.price" placeholder="请输入资金实力" clearable />
                    </el-form-item>

                    <el-form-item label="描述:" prop="info">
                        <el-input v-model="editForm.info" placeholder="请输入描述" clearable />
                    </el-form-item>

                    <el-form-item label="操盘团队（3-5人）:" prop="team">
                        <el-input-number v-model="editForm.team" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入操盘团队（3-5人）" clearable />
                    </el-form-item>


                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";


        export default {
            name: "SysJoin",
            components: {},
            data() {
                return {
                    table: {
                        url: '/join/Join/index',
                        where: {}
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {}, // 表单数据
                    editFormTemp: {},
                    admin_list: [],
                    user_list: [],
                    search_show: false,
                    user_openinfo_list: [],
                    editRules: { // 表单验证规则

                        name: [{
                            required: true,
                            message: '请输入姓名',
                            trigger: 'blur'
                        }],


                        user_id: [{
                            required: true,
                            message: '请选择用户',
                            trigger: 'blur'
                        }],


                        phone: [{
                            required: true,
                            message: '请输入手机号',
                            trigger: 'blur'
                        }],


                        gender: [{
                            required: true,
                            message: '请选择性别',
                            trigger: 'blur'
                        }],


                        industry: [{
                            required: true,
                            message: '请输入行业',
                            trigger: 'blur'
                        }],


                        year_num: [{
                            required: true,
                            message: '请输入从业年数',
                            trigger: 'blur'
                        }],


                        join_area: [{
                            required: true,
                            message: '请输入加盟区域',
                            trigger: 'blur'
                        }],


                        population: [{
                            required: true,
                            message: '请输入人口数',
                            trigger: 'blur'
                        }],


                        price: [{
                            required: true,
                            message: '请输入资金实力',
                            trigger: 'blur'
                        }],


                        info: [{
                            required: true,
                            message: '请输入描述',
                            trigger: 'blur'
                        }],


                        team: [{
                            required: true,
                            message: '请输入操盘团队（3-5人）',
                            trigger: 'blur'
                        }],


                        create_time: [{
                            required: true,
                            message: '请选择创建时间',
                            trigger: 'blur'
                        }],


                        nick_name: [{
                            required: true,
                            message: '请输入用户昵称',
                            trigger: 'blur'
                        }],


                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
            },
            mounted() {

                this.userAllList();
                this.UserOpeninfoAllList();
            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/join/Join/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/join/Join/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的加盟申请吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/join/Join/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/join/Join/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 获取全部会员 */
                userAllList() {
                    this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.user_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/join/Join/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },

                //查询其他信息
                UserOpeninfoAllList() {
                    this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.user_openinfo_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },

            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>